/* ROSHFORT - brand film sound.
   Browsers only allow autoplay when muted, so the film starts muted and the sound
   comes on at the visitor's first interaction with the page. A speaker button on the
   video lets them turn it off or back on, and the sound mutes while the film is
   scrolled out of view. */
(function () {
  'use strict';
  var KEY = 'rf_brandfilm_sound';
  var wanted = null;
  try { var s = sessionStorage.getItem(KEY); if (s === 'on') { wanted = true; } if (s === 'off') { wanted = false; } } catch (e) {}
  function save(v) { try { sessionStorage.setItem(KEY, v ? 'on' : 'off'); } catch (e) {} }

  var sectionEl = null, vid = null, btn = null, inView = true;

  function iconMuted() { return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"></path><line x1="22" y1="9" x2="16" y2="15"></line><line x1="16" y1="9" x2="22" y2="15"></line></svg>'; }
  function iconOn() { return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"></path><path d="M15.5 8.5a5 5 0 0 1 0 7"></path><path d="M18.5 5.5a9 9 0 0 1 0 13"></path></svg>'; }

  function render() {
    if (!btn || !vid) { return; }
    var on = !vid.muted;
    btn.innerHTML = on ? iconOn() : iconMuted();
    btn.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
  }

  function tryPlay() { try { var p = vid.play(); if (p && p.catch) { p.catch(function () {}); } } catch (e) {} }

  function setSound(on) {
    if (!vid) { return; }
    if (on) {
      vid.muted = false;
      vid.removeAttribute('muted');
      try { vid.volume = 1; } catch (e) {}
      var p = null;
      try { p = vid.play(); } catch (e) { p = null; }
      if (p && p.catch) { p.catch(function () { vid.muted = true; tryPlay(); render(); }); }
    } else {
      vid.muted = true;
      tryPlay();
    }
    wanted = on;
    save(on);
    render();
  }

  function makeButton(host) {
    if (btn || !host) { return; }
    try { if (window.getComputedStyle(host).position === 'static') { host.style.position = 'relative'; } } catch (e) {}
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rf-sound-toggle';
    btn.style.cssText = 'position:absolute;right:18px;bottom:18px;z-index:30;width:44px;height:44px;padding:0;border:1px solid rgba(255,255,255,.5);border-radius:50%;background:rgba(0,0,0,.42);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;opacity:.85;transition:opacity .2s,background .2s';
    btn.addEventListener('mouseenter', function () { btn.style.opacity = '1'; btn.style.background = 'rgba(0,0,0,.62)'; });
    btn.addEventListener('mouseleave', function () { btn.style.opacity = '.85'; btn.style.background = 'rgba(0,0,0,.42)'; });
    btn.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); setSound(vid.muted); });
    host.appendChild(btn);
  }

  var gestures = ['pointerdown', 'touchstart', 'keydown', 'wheel'];
  function onGesture() {
    for (var i = 0; i < gestures.length; i++) { document.removeEventListener(gestures[i], onGesture, true); }
    if (wanted === false) { return; }
    wanted = true;
    if (vid && inView && vid.muted) { setSound(true); }
  }
  for (var g = 0; g < gestures.length; g++) { document.addEventListener(gestures[g], onGesture, { capture: true, passive: true }); }

  function watch() {
    if (!sectionEl || !('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        inView = entries[i].isIntersecting && entries[i].intersectionRatio >= 0.3;
        if (!vid) { continue; }
        if (inView) {
          if (wanted === true && vid.muted) { setSound(true); }
        } else if (!vid.muted) {
          vid.muted = true;
          render();
        }
      }
    }, { threshold: [0, 0.3, 0.6] });
    io.observe(sectionEl);
  }

  function attach(v) {
    if (vid === v) { return; }
    vid = v;
    vid.setAttribute('playsinline', '');
    vid.addEventListener('volumechange', render);
    btn = null;
    makeButton(sectionEl.querySelector('video-media') || sectionEl.querySelector('.video-hero') || sectionEl);
    render();
    if (wanted === true && inView) { setTimeout(function () { setSound(true); }, 250); }
  }

  function bind() {
    sectionEl = document.getElementById('shopify-section-video-with-text-overlay') || document.querySelector('[id^="shopify-section"][id*="video-with-text-overlay"]');
    if (!sectionEl) { return false; }
    watch();
    var existing = sectionEl.querySelector('video');
    if (existing) { attach(existing); }
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        var v = sectionEl.querySelector('video');
        if (v && v !== vid) { attach(v); }
      });
      mo.observe(sectionEl, { childList: true, subtree: true });
    }
    return true;
  }

  function start() {
    if (bind()) { return; }
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (bind() || tries > 40) { clearInterval(t); }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function () { vid = null; btn = null; start(); });
})();
